import { produce } from 'immer';
import { INotificationState, TNotificationActions } from '../../types/redux/notifications';
import { NOTIFICATION_SET_SOUND } from '../actions/notifications';

const initialState: INotificationState = {
    sound: false,
};

export const notifications = (state = initialState, action: TNotificationActions): INotificationState => {
    switch (action.type) {
        case NOTIFICATION_SET_SOUND: {
            return produce(state, (draft) => {
                draft.sound = action.payload.value;
            });
        }
        default: {
            return state;
        }
    }
};
